import { setFeedbackMessageAction, setFeedbackMessageVariantAction, openFeedbackMessageAction } from '../actions/actions'
import store from '../store'


class SnackbarService {
  private static instance: SnackbarService

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public showSnackbar = (variant: 'error' | 'success', message: string) => {
    store.dispatch(setFeedbackMessageVariantAction(variant))
    store.dispatch(setFeedbackMessageAction(message))
    store.dispatch(openFeedbackMessageAction())
  }
}

export default SnackbarService




// WEBPACK FOOTER //
// ./src/modules/core/services/SnackbarService.tsx